import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVoicemail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.00016 10.6667L12.0002 10.6667M4.00016 10.6667C5.47292 10.6667 6.66683 9.47276 6.66683 8C6.66683 6.52724 5.47292 5.33334 4.00016 5.33334C2.5274 5.33334 1.3335 6.52724 1.3335 8C1.3335 9.47276 2.5274 10.6667 4.00016 10.6667ZM12.0002 10.6667C13.4729 10.6667 14.6668 9.47276 14.6668 8C14.6668 6.52724 13.4729 5.33334 12.0002 5.33334C10.5274 5.33334 9.3335 6.52724 9.3335 8C9.3335 9.47276 10.5274 10.6667 12.0002 10.6667Z",
		stroke: "#F79009",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgVoicemail);
export { ForwardRef as ReactComponent };
